module.exports = __webpack_public_path__ + "static/media/ico-menu-white.412ca40a.svg";